export type NotificationTabKey = 'announcements' | 'updates' | 'invites';

/** Tab pill order in notifications UI — Announcements is intentionally last. */
export const NOTIFICATION_TAB_ORDER: NotificationTabKey[] = ['updates', 'invites', 'announcements'];

export const DEFAULT_NOTIFICATION_TAB: NotificationTabKey = 'updates';

export const SYSTEM_ANNOUNCEMENT_TYPE = 'system_announcement';

export function isAnnouncementNotification(notification: { notification_type: string }): boolean {
  return notification.notification_type === SYSTEM_ANNOUNCEMENT_TYPE;
}

export function isUpdateNotification(notification: { notification_type: string }): boolean {
  return notification.notification_type !== SYSTEM_ANNOUNCEMENT_TYPE
    && notification.notification_type !== 'workspace_invitation';
}

export function splitNotifications<T extends { notification_type: string }>(notifications: T[]): {
  announcements: T[];
  updates: T[];
} {
  return {
    announcements: notifications.filter(isAnnouncementNotification),
    updates: notifications.filter(isUpdateNotification),
  };
}

export function countUnread<T extends { is_read?: boolean }>(notifications: T[]): number {
  return notifications.filter((notification) => !notification.is_read).length;
}
